var NewslettersSubscription = function () {

    var self = this;

    var alreadySubscribedDiv = $('#newsletter_already_subscribed');
    var successDiv = $('#newsletter_success');

    alreadySubscribedDiv.hide();
    successDiv.hide();


    if(document.querySelector('#subscription_newsletters_online')){
        var elem = document.querySelector('#subscription_newsletters_online');
        var switchery = new Switchery(elem);
    }

    // Newsletter subscription when the user is login
        function setSwitchery(switchElement, checkedBool) {
            if((checkedBool && !switchElement.isChecked()) || (!checkedBool && switchElement.isChecked())) {
                switchElement.setPosition(true);
                switchElement.handleOnchange(true);
            }
        }
        function sendSubscription(offlineUserEmail = null){
            $.ajax({
                method: 'GET',
                url: '/newsletters/subscription',
                data: 'email='+offlineUserEmail,
                success: function (data) {

                    if(data === 'already_subscribed'){
                        successDiv.hide();
                        alreadySubscribedDiv.show();
                    } else if (data === 'success'){
                        alreadySubscribedDiv.hide();
                        successDiv.show();
                    }

                    // CoreNotification.flashNotify(data, 'success')
                },
            });
        }
        this.subscriptionWithLoginUser = function () {

            $('#subscription_newsletters_online').on('change', function () {
                var state = $(this).prop('checked');

                if (!state) {
                    swal({
                        title: 'Êtes-vous sûr ?',
                        allowOutsideClick: true,
                        type: 'warning',
                        showCancelButton: true,
                        closeOnConfirm: true,
                        closeOnCancel: true,
                        confirmButtonColor: '#D2282D',
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Oui !',
                        showLoaderOnConfirm: false,
                        preConfirm: function () {
                            return new Promise(function (resolve) {
                                sendSubscription();
                                swal.close();
                            });
                        }
                    }).then(function (result) {
                        setSwitchery(switchery, true);
                        swal.close();
                    });
                }else {
                    sendSubscription();
                }
            });
        }

    //Newsletter subscription when the user isn't login
        this.subscriptionWithNoLoginUser = function () {
            $($('#subscription_newsletters_offline').siblings('span')[0]).on('click', function (e) {
                sendSubscription($('#subscription_newsletters_offline').val());
            });
        };

    return {
        init: function () {
            self.subscriptionWithLoginUser();
            self.subscriptionWithNoLoginUser();
        }
    };

}();

$(window).on('load',function () {
    NewslettersSubscription.init();
});